import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // 1. Animasi Masuk (Tunggu sebentar agar transisi CSS jalan)
    setTimeout(() => {
      this.element.classList.remove("translate-x-full", "opacity-0")
    }, 100)

    // 2. Timer Otomatis Hilang (3000ms = 3 detik)
    this.timeout = setTimeout(() => {
      this.close()
    }, 3000)
  }

  close() {
    // 3. Animasi Keluar
    this.element.classList.add("translate-x-full", "opacity-0")

    // 4. Hapus dari DOM setelah animasi selesai (300ms sesuai duration-300)
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}